import { IconButton, Paper, Typography } from "@mui/material";
import { Search } from "@mui/icons-material";
import theme from "Theme/AppTheme";
import AcxMainTextField from "components/UI/AcxMainTextField";
import { AmdTimelineWithGraph } from "components/UI/Timeline/AmdTimelineWithGraph";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { extractGuid } from "utils/StringUtils";

const FileTimeline = observer(() => {
    const [searchText, setSearchText] = useState("");
    const [submittedAmdId, setSubmittedAmdId] = useState("");
    const [searchError, setSearchError] = useState<string>();

    const submitSearch = () => {
        const normalizedAmdId = extractGuid(searchText);
        if (!normalizedAmdId) {
            setSearchError("Enter a valid AMD ID.");
            setSubmittedAmdId("");
            return;
        }

        setSearchError(undefined);
        setSubmittedAmdId(normalizedAmdId);
    };

    const endAdornment = (
        <IconButton
            aria-label="Search for AMD timeline"
            size="small"
            onClick={submitSearch}
        >
            <Search fontSize="small" />
        </IconButton>
    );

    return (
        <Paper
            style={{
                height: "100%",
                overflow: "auto",
                background: theme.palette.lightgray.main,
                position: "relative",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        minHeight: "70px",
                        alignItems: "center",
                        background: "white",
                        boxShadow:
                            "0 0 3px 0 rgb(0 0 0 / 5%), 0 1px 1px 0 rgb(0 0 0 / 5%)",
                    }}
                >
                    <div
                        style={{
                            marginLeft: "12px",
                            marginRight: "auto",
                        }}
                    >
                        <Typography variant="h5">
                            File Processing Timeline
                        </Typography>
                    </div>
                    <div
                        style={{
                            marginLeft: "auto",
                            marginRight: "12px",
                        }}
                    >
                        <AcxMainTextField
                            id="amdSearch"
                            placeholderText="Find File by AMD ID"
                            type="text"
                            containerStyle={{
                                width: "clamp(320px, 35vw, 480px)",
                            }}
                            fullWidth
                            value={searchText}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSearchText(value);
                                setSearchError(undefined);
                                setSubmittedAmdId(extractGuid(value) ?? "");
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") submitSearch();
                            }}
                            error={Boolean(searchError)}
                            errorHelper={searchError}
                            helperText={searchError}
                            endAdornment={endAdornment}
                        />
                    </div>
                </div>
                <AmdTimelineWithGraph amdId={submittedAmdId} />
            </div>
        </Paper>
    );
});

export default FileTimeline;
